import client from './client';

export interface UserSearchResult {
  id: string;
  email: string;
  name: string;
}

export async function searchUsers(query: string, limit: number = 10, signal?: AbortSignal): Promise<UserSearchResult[]> {
  const response = await client.get<UserSearchResult[]>('/users/search', {
    params: { q: query, limit },
    signal,
  });
  return response.data;
}
